export const ADD_DOWNLOAD_SOFT = 'ADD_DOWNLOAD_SOFT';
export const REMOVE_DOWNLOAD_SOFT = 'REMOVE_DOWNLOAD_SOFT';
export const UPDATE_DOWNLOAD_SOFT_STATUS = 'UPDATE_DOWNLOAD_SOFT_STATUS';
export const UPDATE_DOWNLOAD_PROGRESS = 'UPDATE_DOWNLOAD_PROGRESS';
export const ADD_WELCOMEIDS_TO_DOWNLOAD = 'ADD_WELCOMEIDS_TO_DOWNLOAD';
